import { useEffect, useRef, useState } from "react";
const OTPInput = ({
  otp,
  setOtp,
}: {
  otp: string[];
  setOtp: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
  const [activeOtpIndex, setActiveOtpIndex] = useState(0);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleOnChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const raw = e.target.value ?? "";
    const digit = raw.replace(/\D/g, "").slice(-1); // keep last digit only

    const next = [...otp];
    next[index] = digit;
    setOtp(next);

    if (!digit) {
      setActiveOtpIndex(Math.max(index - 1, 0));
      return;
    }

    setActiveOtpIndex(Math.min(index + 1, otp.length - 1));
  };

  const handleOnPaste = (
    e: React.ClipboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    const pasted = e.clipboardData.getData("text");
    const digits = pasted.replace(/\D/g, "");
    if (!digits) return;

    e.preventDefault();

    const next = [...otp];
    let writeIndex = index;
    for (const ch of digits) {
      if (writeIndex >= next.length) break;
      next[writeIndex] = ch;
      writeIndex += 1;
    }

    setOtp(next);
    setActiveOtpIndex(Math.min(writeIndex, next.length - 1));
  };

  const handleOnKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    if (e.key === "Backspace" && !otp[index]) {
      setActiveOtpIndex(Math.max(index - 1, 0));
    }
    if (e.key === "ArrowLeft") {
      setActiveOtpIndex(Math.max(index - 1, 0));
    }
    if (e.key === "ArrowRight") {
      setActiveOtpIndex(Math.min(index + 1, otp.length - 1));
    }
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, [activeOtpIndex]);
  return (
    <div className="w-full flex items-center justify-between gap-[11px] ">
      {otp.map((value, index) => (
        <input
          key={index}
          ref={index === activeOtpIndex ? inputRef : null}
          className="otpinput Nunito appearance-none h-[43px] w-full rounded-[10px] border-[1.5px] border-[#D1D5DB] focus:border-brand-textGrey focus:outline-none flex items-center justify-center text-center bg-[#F9FAFB] text-[#6B7280] text-[16px] font-[300] "
          type="text"
          inputMode="numeric"
          autoComplete={index === 0 ? "one-time-code" : "off"}
          pattern="[0-9]*"
          maxLength={1}
          onChange={(e) => handleOnChange(e, index)}
          onPaste={(e) => handleOnPaste(e, index)}
          onKeyDown={(e) => handleOnKeyDown(e, index)}
          value={otp[index]}
        />
      ))}
    </div>
  );
};

export default OTPInput;
